module.exports = "<h1>{{announcement?.title}}</h1>\r\n<ng-template [ngIf]=\"announcement?.detail\">\r\n  <markdown [data]=\"announcement.detail\"></markdown>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcement-view/announcement-view.component.html
// module id = ../../../../../src/app/announcements/announcement-view/announcement-view.component.html
// module chunks = main